module.exports = __webpack_public_path__ + "83981a00ca853311fff64a9efe58c8b6.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/clients/veo veo.png
// module id = 631
// module chunks = 0